module.exports = __webpack_public_path__ + "img/yiguoqi.18edb3fa.png";